module.exports = "/_next/static/images/reportcard-logo-d73d2f5822e118bf2d9bade2977fff74.svg";